module.exports = __webpack_public_path__ + "static/media/Logo-Original.bc95a48b.svg";